import type { Board } from "../board";
import type { Direction } from "../direction";
import { directionDelta } from "../direction";
import type { Player } from "../player";
import { DrillBullet } from "../projectiles/drillBullet";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { ParticleType } from "../particleType";
import { Weapon } from "../weapon";
import { WeaponVisual } from "../weaponVisual";

export class DrillLauncher extends Weapon {
	static key = "DrillLauncher";
	constructor(owner: Player, ammo: number = 5) {
		super(owner, ammo);
	}

	override getMuzzleFlashType(): ParticleType {
		return ParticleType.MUZZLE_FLASH;
	}

	override getWeaponVisual(): WeaponVisual {
		return WeaponVisual.CANNON;
	}

	fire(direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.DRILL_SINGLE_RUN));
		const spawnPos = this.owner.xy.add(directionDelta(direction));
		const bullet = new DrillBullet(spawnPos, direction);
		this.shotProjectile(board, bullet);
	}

	static deserialize(data: any, owner: Player): DrillLauncher {
		const gun = new DrillLauncher(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
